// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".547ee6f71109fc83d4fa5c1a8550b746ea57d41f.chunk.bundle.js";
};